/**
 * @file LightingDomainRegistry.ts
 * @author Rapoo Device SDK Team
 * @date 2026-06-22
 * @description 灯效领域注册表
 */

import { LightingDomainDescriptor, LightingDomainType } from '../../types/lightingDomain'

export class LightingDomainRegistry {
  private static domains = new Map<LightingDomainType, LightingDomainDescriptor>()

  static register(domain: LightingDomainDescriptor): void {
    if (this.domains.has(domain.type)) {
      console.warn(`[LightingDomainRegistry] Domain '${domain.type}' already registered`)
    }
    this.domains.set(domain.type, domain)
  }

  static get(type: LightingDomainType): LightingDomainDescriptor {
    const domain = this.domains.get(type)
    if (!domain) throw new Error(`[LightingDomainRegistry] Unknown domain: ${type}`)
    return domain
  }

  static getAllTypes(): LightingDomainType[] {
    return Array.from(this.domains.keys())
  }

  static has(type: LightingDomainType): boolean {
    return this.domains.has(type)
  }

  static clear(): void {
    this.domains.clear()
  }
}
